import TaxReportsActions from "../../../../redux/actions/Reports/TaxReport";
export default () => {
    return new TaxReportsActions();
};
